import { render, staticRenderFns } from "./apartments-overview-result.vue?vue&type=template&id=2e0361c4&scoped=true&"
import script from "./apartments-overview-result.ts?vue&type=script&lang=ts&"
export * from "./apartments-overview-result.ts?vue&type=script&lang=ts&"
import style0 from "./apartments-overview-result.scss?vue&type=style&index=0&id=2e0361c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0361c4",
  null
  
)

export default component.exports